import {Row, Col, Typography} from "antd";

import ForgottenPasswordForm from "components/forms/ForgottenPassword";
import {useTranslation} from "next-i18next";
import {fetchTranslations} from "utils/fetches";

const ForgottenPassword = () => {
  const {t} = useTranslation();

  return (
    <div
      className="container guttered"
      style={{maxWidth: "600px", margin: "40px auto"}}
    >
      <Row gutter={[20, 16]}>
        <Col xs={24}>
          <Typography.Title level={2}>{t("Zabudnuté heslo")}</Typography.Title>
          <Typography.Text>
            {t("Zabudli ste heslo? Zadajte email, ktorý používate k vašemu účtu, a my vám pomôžeme obnoviť vaše heslo")}
          </Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <ForgottenPasswordForm/>
        </Col>
      </Row>
    </div>
  );
};

export default ForgottenPassword;

export async function getServerSideProps({locale}) {
  return {
    props: {
      ...(await fetchTranslations(locale))
    }
  };
}